module.exports = __webpack_public_path__ + "static/media/ic_american.add316e9.png";